class ShopTheLook extends HTMLElement {
  constructor() {
    super();
    this.scrollElement = this.querySelector('.shop-the-look__scroll');
    this.scrollMoreShadowElement = this.querySelector('.shop-the-look__scroll-shadow');
    this.productItems = this.querySelectorAll('.shop-the-look__product-item');
    this.updateScrollHeight();
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('resize', this.updateScrollHeight.bind(this));
    if (this.scrollElement && this.scrollMoreShadowElement) {
      this.scrollElement.addEventListener('scroll', this.handleScroll.bind(this));
    }
    // Add event listeners to inputs within each productItem
    this.productItems.forEach((productItem) => {
      const inputs = productItem.querySelectorAll('input');
      const atcPriceElement = productItem.querySelector('span#atcPrice');
      inputs.forEach((input) => {
        input.addEventListener('change', (event) => this.handleInputChange(event, productItem, atcPriceElement));
      });
    });
    // Add event listeners to swatch inputs to switch between looks
    this.addSwatchListeners();
  }

  addSwatchListeners() {
    const swatchItems = this.querySelectorAll('.shop-the-look__swatches .swatch-item');
    swatchItems.forEach((item) => {
      item.addEventListener('click', (event) => this.handleSwatchChange(event));
    });
  }

  handleSwatchChange(event) {
    const swatchItem = event.currentTarget;
    if (!swatchItem) return;
    
    const targetIndex = swatchItem.getAttribute('data-index');
    if (!targetIndex) return;

    // Remove swatch-active class from all swatches immediately
    const allSwatchItems = this.querySelectorAll('.swatch-item');
    allSwatchItems.forEach((item) => {
      item.classList.remove('swatch-active');
    });
    
    // Add swatch-active class to all matching swatches with the same index
    const matchingSwatches = this.querySelectorAll(`.swatch-item[data-index="${targetIndex}"]`);
    matchingSwatches.forEach((swatch) => {
      swatch.classList.add('swatch-active');
      
      // Check the radio button in each matching swatch
      const radioInput = swatch.querySelector('.swatch-radio');
      if (radioInput) {
        radioInput.checked = true;
      }
    });

    // Get target container
    const targetContainer = this.querySelector(`.shop-the-look__look-container[data-index="${targetIndex}"]`);
    
    // Find currently visible container
    const currentContainer = this.querySelector('.shop-the-look__look-container:not([hidden])');

    if (currentContainer && currentContainer !== targetContainer) {
      // Check if headings are different, so we know if to animate swapping out the header
      const currentHeading = currentContainer.querySelector('.shop-the-look__products-container h2');
      const targetHeading = targetContainer?.querySelector('.shop-the-look__products-container h2');
      const headingsAreDifferent = currentHeading && targetHeading && 
                                   currentHeading.textContent.trim() !== targetHeading.textContent.trim();
      
      // Fade out current container's content
      currentContainer.classList.add('fading-out');
      if (headingsAreDifferent) {
        currentContainer.classList.add('fade-heading');
      }
      
      // After fade out completes, switch containers
      setTimeout(() => {
        currentContainer.setAttribute('hidden', '');
        currentContainer.classList.remove('fading-out', 'fade-heading');
        
        if (targetContainer) {
          targetContainer.classList.add('fading-in');
          if (headingsAreDifferent) {
            targetContainer.classList.add('fade-heading');
          }
          targetContainer.removeAttribute('hidden');
          targetContainer.offsetHeight;

          requestAnimationFrame(() => {
            targetContainer.classList.remove('fading-in', 'fade-heading');
          });
        }

        // Update scroll height for the newly visible container
        this.productItems = this.querySelectorAll('.shop-the-look__product-item');
        this.updateScrollHeight();
      }, 200);
    } else if (targetContainer) {
      // No transition needed, just show it
      targetContainer.removeAttribute('hidden');
      this.productItems = this.querySelectorAll('.shop-the-look__product-item');
      this.updateScrollHeight();
    }
  }

  updateScrollHeight() {
    if (!this.scrollElement) return;

    if (window.innerWidth > 1024 && this.productItems.length >= 3) {
      const firstItemHeight = this.productItems[0].offsetHeight;
      const secondItemHeight = this.productItems[1].offsetHeight;
      const thirdItemHeight = this.productItems[2].offsetHeight;
      const combinedHeight = firstItemHeight + secondItemHeight + thirdItemHeight + 44;
      this.scrollElement.style.maxHeight = `${combinedHeight}px`;
    } else {
      this.scrollElement.style.maxHeight = '';
    }
  }

  handleScroll() {
    const { scrollTop, clientHeight, scrollHeight } = this.scrollElement;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;
    this.updateScrollMoreShadow(isNearBottom);
  }

  updateScrollMoreShadow(isNearBottom) {
    this.scrollMoreShadowElement.style.opacity = isNearBottom ? 0 : 1;
  }

  handleInputChange(event, productItem, atcPriceElement) {
    const selectedInput = productItem.querySelector('input:checked');
    if (selectedInput && atcPriceElement) {
      const price = selectedInput.getAttribute('data-price');
      if (price) {
        // Parse the price as an integer (in cents)
        const priceInCents = parseInt(price, 10);
        if (!isNaN(priceInCents)) {
          // Format the price using Shopify.formatMoney and remove ".00"
          const formattedPrice = Shopify.formatMoney(priceInCents).replace(".00", "");
          atcPriceElement.textContent = formattedPrice;
        }
      }
    }
  }
}

if (!customElements.get("shop-the-look")) {
  customElements.define("shop-the-look", ShopTheLook);
}
